// recipe-product-cart-submission.js

document.addEventListener('DOMContentLoaded', () => {
  const quantityInputs = document.querySelectorAll('.quantity-main-div');
  const variantIdElements = document.querySelectorAll('#variant-id'); // Assuming multiple elements

  const addToCartBtn = document.querySelector('.add-to-cart-btn');
  // const addRecommendationToCart = document.querySelector('.add-rec-to-cart');

  quantityInputs.forEach((q, index) => {
    const quantityInput = q.querySelector('.quantity_input');
    let quantityValue = parseInt(quantityInput.innerHTML);
    const maxQuantity = parseInt(quantityInput.getAttribute('max')) || Infinity; // Default to Infinity if not set
    const minus = q.querySelector('.minus');
    const plus = q.querySelector('.plus');
    const cartQuantity = parseInt(quantityInput.getAttribute('data-cart-quantity'));
    // Function to dispatch event
    function validateAndUpdateQuantity(flag, button) {
      quantityInput.dispatchEvent(
        new CustomEvent('quantityValidation', {
          detail: {
            isOverMax: flag,
            maxQuantity,
            currentQuantity: quantityValue,
            button,
            cartQuantity,
          },
        })
      );
    }

    minus.addEventListener('click', () => {
      if (quantityValue - 1 > 0) {
        quantityValue--;
        quantityInput.innerHTML = quantityValue;
        addToCartBtn.setAttribute('value', quantityValue);
        quantityInput.setAttribute('value', quantityValue);
      }
      // Check if alert should be hidden
      validateAndUpdateQuantity(false, plus); //Only pass the plus button
    });

    plus.addEventListener('click', () => {
      if (quantityValue + 1 > maxQuantity) {
        validateAndUpdateQuantity(true, plus);
        return;
      }

      if (quantityValue < maxQuantity) {
        quantityValue++;
        quantityInput.innerHTML = quantityValue;
        addToCartBtn.setAttribute('value', quantityValue);
        quantityInput.setAttribute('value', quantityValue);
      }

      // Always validate after attempting to increment
      validateAndUpdateQuantity(false, plus);
    });
  });

  const addToCartCustom = async (formData) => {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      console.log('Added to cart:', data);

      // Extract product details
      const productName = data.title || data.product_title || 'Product';
      const productImage =
        data.image || (data.featured_image && data.featured_image.url) || '/path/to/default/image.jpg';

      // Dispatch the 'cart:added' event with product details
      const event = new CustomEvent('cart:added', {
        detail: {
          name: productName,
          image: productImage,
        },
      });
      document.dispatchEvent(event);

      await window.updateCartDrawer();
      // window.toggleCartDrawer(true);
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error);
    }
  };

  const updateCartDrawerCustom = async () => {
    try {
      await window.updateCartDrawer();
    } catch (error) {
      console.error('Failed to update cart drawer:', error);
    }
  };

  addToCartBtn.addEventListener('click', async (e) => {
    e.preventDefault();

    // Collect all variant IDs and their quantities if multiple products are being added
    const formData = new FormData();

    // Assuming each `#variant-id` corresponds to a product card
    variantIdElements.forEach((variantIdElement, idx) => {
      const quantity = parseInt(addToCartBtn.getAttribute('value')) || 1;
      formData.append('id', parseInt(variantIdElement.getAttribute("data-variant-id")));
      formData.append('quantity', quantity);
    });

    await addToCartCustom(formData);
  });

  /*
  addRecommendationToCart.addEventListener('click', async (e) => {
    e.preventDefault();
    const formData = new FormData();
    const variantId = addRecommendationToCart.getAttribute('data-variant-id'); // Use data attributes
    formData.append('id', variantId);
    formData.append('quantity', 1);

    await addToCartCustom(formData);
  });
  */
});
